import { StatusesEnums } from 'dashboard-services/api/statuses';
import { ActionService } from 'dashboard-services/services';
import { statusBoxActions } from 'primary-components';

export default (() => {

  const PIPELINE_TAGS = ["insight"]

  const EMAIL_TASK = "task-email-lambda",
        DOWNLOADER_TASK = "task-insight-tiles-downloader",
        TEMPLATE_TASK = "task-generic-html-template",
        SCHEDULER_TASK = "cron-trigger",
        GENERIC_TASKS = [EMAIL_TASK, TEMPLATE_TASK, DOWNLOADER_TASK]

  const CHECK_IN_PROGRESS_STEP = "CHECK_IN_PROGRESS_STEP",
        PIPELINE_NOT_EXIST_STEP = "PIPELINE_NOT_EXIST_STEP",
        PIPELINE_EXIST_STEP =  "PIPELINE_EXIST_STEP",
        PIPELINE_IN_PROGRESS_STEP = "PIPELINE_IN_PROGRESS_STEP",
        ERROR_STEP = "ERROR_STEP" 

  const TEMPLATE_GROUP = "Pipeline templates",
        TEMPLATE_NAME = "insight-exporter"

  const ON_CHANGE_EXPORT = 'ON_CHANGE_EXPORT_STATE_CUSTOM_INSIGHT'
  const onChangeExport = ActionService.makeActionCreator(ON_CHANGE_EXPORT, 'value', 'name')

  const ON_CHANGE_EXPORT_INIT_DETAILS = 'ON_CHANGE_EXPORT_STATE_CUSTOM_INSIGHT_INIT_DETAILS'
  const onChangeExportInitDetails = ActionService.makeActionCreator(ON_CHANGE_EXPORT_INIT_DETAILS, 'value', 'name')

  const ON_CLEAR_EXPORT = 'ON_CLEAR_EXPORT_STATE_CUSTOM_INSIGHT'
  const onClearExport = ActionService.makeActionCreator(ON_CLEAR_EXPORT)

  const setErrorMessage = error => dispatch => dispatch(onChangeExport(error, "error"))

  const getPipelineName = () => (_, getState) => {
    const fileName = getState().insightState.customState.info.fileName,
          insightName = fileName.replace(".json", "")
          
    return `${insightName} email exporter`
  }

  const createPipeline = ({ getPipelineCall, createPipelineCall }) => (dispatch, getState) => {
    const { fileName, groupName } = getState().insightState.customState.info,
          { emailSubject, recipients, reportTitle } = getState().insightState.customState.emailExportState,
          pipelineName = dispatch(getPipelineName())

    dispatch(onChangeExport(PIPELINE_IN_PROGRESS_STEP, "step"))    
    return getPipelineCall({ pipelineName: TEMPLATE_NAME, groupName: TEMPLATE_GROUP, version: "latest" })
      .then(res => {
        res.batchConfig.tasks.forEach(task => {
          if(task.taskName === EMAIL_TASK){
            task.taskOverrides.params.Recipients = recipients.join(",")
            task.taskOverrides.params.Subject = emailSubject
          } else if (task.taskName === TEMPLATE_TASK){
            task.taskOverrides.params["Document Title"] = reportTitle
            task.taskOverrides.params["Output Group"] = groupName
            task.taskOverrides.params["Output File Name"] = `${pipelineName}-html-template.html`
          } else if (task.taskName === DOWNLOADER_TASK){
            task.taskOverrides.params["Output Group"] = groupName
            task.taskOverrides.params.Insight = JSON.stringify({
              name: fileName,
              groupName
            })
          }
        })
        return createPipelineCall({ name: pipelineName, groupName, tasks: res.batchConfig.tasks, payload: res.payload, tags: PIPELINE_TAGS })
          .then(() => dispatch(onChangeExport(PIPELINE_EXIST_STEP, "step")))
          .catch(() => dispatch(onChangeExport(ERROR_STEP, "step")))
      })
      .catch(() => dispatch(onChangeExport(ERROR_STEP, "step")))
  }

  const executePipeline = ({ pipelineId, originalPipelineId, executePipelineCall }) => (dispatch, getState) => {
    const { groupName } = getState().insightState.customState.info,
          pipelineName = dispatch(getPipelineName())

    return executePipelineCall({ pipelineId: pipelineId || originalPipelineId })
      .then(({ jobId } = {}) => {
        if(jobId){
          dispatch(statusBoxActions.addJob({
            jobId, 
            displayName: pipelineName, 
            subtitle: groupName,
            isDisabled: false,
            type: StatusesEnums.STATUS_TYPE.PIPELINE
          }))
        }
      })
  }

  const updatePipeline = ({ originalPipelineDetails, currentDetails, updatePipelineCall }) => (dispatch, getState) => {
    const groupName = getState().insightState.customState.info.groupName,
          { emailSubject, recipients, reportTitle } = currentDetails,
          pipelineName = dispatch(getPipelineName())

    originalPipelineDetails.batchConfig.tasks.forEach(task => {
      if(task?.taskName === EMAIL_TASK){
        task.taskOverrides.params.Recipients = recipients?.join(",")
        task.taskOverrides.params.Subject = emailSubject
      } else if (task?.taskName === TEMPLATE_TASK){
        task.taskOverrides.params["Document Title"] = reportTitle
      }
    })

    return updatePipelineCall({ name: pipelineName, groupName, tasks: originalPipelineDetails.batchConfig.tasks, payload: originalPipelineDetails.payload, pipelineId: originalPipelineDetails?.pipeline?.id, tags: PIPELINE_TAGS, markdownId: originalPipelineDetails.pipeline.markdownId })
  }

  return {
    CHECK_IN_PROGRESS_STEP,
    createPipeline,
    ERROR_STEP,
    executePipeline,
    getPipelineName,
    ON_CHANGE_EXPORT,
    ON_CHANGE_EXPORT_INIT_DETAILS,
    ON_CLEAR_EXPORT,
    onChangeExport,
    onChangeExportInitDetails,
    onClearExport,
    PIPELINE_EXIST_STEP,
    PIPELINE_IN_PROGRESS_STEP,
    PIPELINE_NOT_EXIST_STEP,
    PIPELINE_TAGS,
    updatePipeline,
    setErrorMessage,
    GENERIC_TASKS,
    TEMPLATE_TASK,
    EMAIL_TASK,
    SCHEDULER_TASK
	}
})()